export const VAT_CODES = Object.freeze({
  VAT0: 'VAT0',
  VAT1: 'VAT1',
  VAT2: 'VAT2',
})
export const VAT_CODE_DEFAULTS = Object.freeze({
  STANDARD: VAT_CODES.VAT1,
  REDUCED: VAT_CODES.VAT2,
})

export const REVENUE_ACCOUNTS_SMALL_BUSINESS = Object.freeze({
  0: 8195,
  5: null,
  7: null,
  16: null,
  19: null,
})

// Auswählbare Erlöskonten je Steuersatz
export const REVENUE_ACCOUNTS_MAP = Object.freeze({
  0: [8100, 8105, 8110, 8120, 8125, 8130, 8140, 8150, 8195, 8335, 8336, 8337, 8338, 8339],
  5: [8300, 8310],
  7: [8300, 8310],
  16: [8315, 8400],
  19: [8315, 8400],
})
